// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ReportDetails_wrapper__2WrVU","table":"ReportDetails_table__1CRnp","toolbar":"ReportDetails_toolbar__IsgXZ"};